import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    /* Primary color - current blue */
    --primary: #0066FF;
    --primary-dark: #0055D4;
    --primary-light: #4D94FF;
    
    /* Secondary color - complementary to blue */
    --secondary: #6E7FF7;
    --secondary-dark: #5A6AE0;
    --secondary-light: #8A9AF9;
    
    /* Tertiary color - complementary to blue */
    --tertiary: #00B8D9;
    --tertiary-dark: #0097B3;
    --tertiary-light: #33C9E0;
    
    /* Status colors - Red, Amber, Green */
    --success: #28A745; /* Green */
    --warning: #FFC107; /* Amber */
    --danger: #DC3545;  /* Red */
    
    /* Background and text colors */
    --background: #FFFFFF;
    --background-light: #F8F9FA;
    --background-dark: #F1F3F5;
    
    --text-primary: #2D3748;
    --text-secondary: #718096;
    --text-tertiary: #A0AEC0;
    
    /* Border and shadow */
    --border-color: rgba(0, 102, 255, 0.1);
    --gradient-primary: linear-gradient(135deg, #0066FF 0%, #5E17EB 100%);
    --box-shadow: 0 4px 12px rgba(0, 102, 255, 0.05);
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background-color: var(--background);
    color: var(--text-primary);
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 0.5rem;
    font-weight: 600;
    line-height: 1.2;
  }

  h1 {
    font-size: 2.5rem;
  }

  h2 {
    font-size: 2rem;
  }

  h3 {
    font-size: 1.75rem;
  }

  h4 {
    font-size: 1.5rem;
  }

  h5 {
    font-size: 1.25rem;
  }

  h6 {
    font-size: 1rem;
  }

  p {
    margin-bottom: 1rem;
  }

  a {
    color: var(--primary);
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }

  button {
    cursor: pointer;
  }

  input, button, select, textarea {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(0, 102, 255, 0.2);
    border-radius: 4px;
    
    &:hover {
      background: rgba(0, 102, 255, 0.3);
    }
  }

  /* Utility classes */
  .text-center {
    text-align: center;
  }

  .text-right {
    text-align: right;
  }

  .text-left {
    text-align: left;
  }

  .d-flex {
    display: flex;
  }

  .flex-column {
    flex-direction: column;
  }

  .justify-content-between {
    justify-content: space-between;
  }

  .justify-content-center {
    justify-content: center;
  }

  .align-items-center {
    align-items: center;
  }

  .w-100 {
    width: 100%;
  }

  .h-100 {
    height: 100%;
  }

  .m-0 {
    margin: 0;
  }

  .p-0 {
    padding: 0;
  }
`;

export default GlobalStyles;
